import React, { useState, useEffect } from 'react'
import { Typography, Chip, Grid } from '@material-ui/core'
import { useDropzone } from 'react-dropzone'
import TRANSLATE from 'utils/constants'
import IMG_UPLOAD from '../../images/components/bg-upload-files.png'

// TODO; NO USAR, se eliminará, usar Dragzone.
const DragZoneUpload = ({
   multiple = true,
   maxFiles = 0,
   formats = '',
   color = 'normal',
   content = '',
   showList = false,
   fileListCallback,
   height = '250px'
}) => {
   const colors = {
      normal: {
         borderColor: 'rgb(143 143 143 / 61%)',
         backgroundColor: 'rgb(230 230 230 / 38%)'
      },
      primary: {
         borderColor: '#3264dc',
         backgroundColor: '#3264dc17'
      },
      white: {
         borderColor: 'rgb(143 143 143 / 61%)',
         backgroundColor: '#fff'
      }
   }

   const style = {
      dragZone: {
         border: `2px dashed ${colors[color].borderColor}`,
         width: '100%',
         overflow: 'hidden',
         boderColor: 'rgb(232 232 232)',
         borderRadius: '4px',
         backgroundColor: `${colors[color].backgroundColor}`,
         cursor: 'pointer',
         position: 'relative',
         display: 'flex',
         justifyContent: 'center',
         alignItems: 'center',
         height
      },
      dragZoneContent: {
         textAlign: 'center'
      },
      legendText: {
         opacity: '0.7',
         alignItems: 'center',
         display: 'flex',
         margin: '0 2em 0 2em'
      },
      fileList: {
         margin: '10px'
      },
      hasError: {
         borderColor: 'red'
      }
   }

   const [fileList, setFileList] = useState([])
   const [someError, setSomeError] = useState('')
   const [refreshComponent, setRefreshComponent] = useState(0)

   const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
      useDropzone({
         accept: formats,
         multiple,
         maxFiles
      })

   useEffect(() => {
      setSomeError('')
      handleFileAdd()
   }, [acceptedFiles])

   useEffect(() => {
      fileListCallback(fileList)
   }, [fileList])

   useEffect(() => {
      handleRejectedFiles()
   }, [fileRejections])

   const FilesListTags = () =>
      fileList.map((file, index) => (
         <Chip
            size="small"
            key={index}
            label={`${file.path} - ${file.size} bytes`}
            onDelete={() => handleFileDelete(index)}
            style={{ marginRight: 10 }}
         />
      ))

   const handleFileAdd = () => {
      if (fileList.length) {
         acceptedFiles.forEach(newFile => {
            if (!fileList.some(file => file.name === newFile.name)) {
               setFileList(previousFiles => [...previousFiles, newFile])
            }
         })
      } else {
         setFileList(acceptedFiles)
      }
   }

   const handleFileDelete = index => {
      const newFileList = [...fileList]
      newFileList.splice(index, 1)
      setFileList(newFileList)
      setRefreshComponent(old => old + 1)
   }

   const handleRejectedFiles = () => {
      if (fileRejections.length > 0) {
         setSomeError('Archivo no permitido')
      }
   }

   const showFileList = fileList.length & showList

   return (
      <Grid>
         <Grid item xs={12}>
            <div
               style={
                  someError
                     ? { ...style.dragZone, ...style.hasError }
                     : style.dragZone
               }
               {...getRootProps()}
            >
               <div style={style.dragZoneContent}>
                  <img alt="image upload" src={IMG_UPLOAD} />
                  <input {...getInputProps()} />
                  <p style={style.legendText}>
                     {content
                        ? content
                        : TRANSLATE.LABELS.FILE_DRAG_LEGEND.replace(
                             '%n%',
                             formats
                          )}
                  </p>
               </div>
            </div>
         </Grid>
         <Grid item xs={12}>
            {!!someError && (
               <Typography variant="caption" color="error">
                  {someError}
               </Typography>
            )}
            {showFileList ? (
               <div style={{ padding: 5 }}>
                  <h4>Archivos:</h4>
                  <FilesListTags key={refreshComponent} />
               </div>
            ) : (
               ''
            )}
         </Grid>
      </Grid>
   )
}

export default DragZoneUpload
